import * as React from "react";
import { MeditationPrescriptionItemRequest } from "@curefit/gmf-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import IMeditationPrescription from "../../../models/IMeditationPrescription";
import {isEmpty as _isEmpty} from "lodash"
import AppUtils from "../../../utils/AppUtils";
import {AppConstants} from "../../../utils/AppConstants";

/**
 * Created by aditya on 28/06/18.
 */

let PatientMindfulnessPlansRecommendationHeaderInfos: ICustomHeaderInfo[] = [
    {label: "recommendtions", display: "MINDFULNESS RECOMMENDATIONS"}
];

let PatientMindfulnessPlansSleepHeaderInfos: ICustomHeaderInfo[] = [
    {label: "sleep", display: "SLEEP"}
];

let PatientFitnessPlansEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "activity", display: "ACTIVITY", mandatory: true},
    {label: "frequency", display: "FREQUENCY", mandatory: true},
    {label: "duration", display: "DURATION", mandatory: true},
    {label: "advice", display: "ADVICE"},
    {label: "reminder", display: "REMINDER"}
];

const LifestyleGuidelinesHeaderInfos: ICustomHeaderInfo[] = [
    { label: "guidelines", display: "GUIDELINES" }
];


export interface PatientMindfulnessPlansEditorProps {
    consultationType?: string,
    fetchStaticLabTestsData?: (input: string) => Promise<any>,
    savedMindfulnessPlans: {item: IMeditationPrescription}[],
    updateSavedMindfulnessPlans: (updatedLabTests: {item: IMeditationPrescription}[]) => void,
    updatedMindfulnessPlans: {item: IMeditationPrescription}[],
    updateMindfulnessPlans: (updatedLabTests: {item: IMeditationPrescription}[]) => void,
    fetchFitnessActivities?: (input: string) => Promise<any>;
    updatedMindGuidelines: {item: PrescriptionItemGuideline}[],
    updateMindPlanGuidelines: (updatedGuidelines: {item: PrescriptionItemGuideline}[]) => void,
    consultationId: number,
    doctorId: number,
    doctorType: string,
    doctorName: string
}

class MindfulnessPlansEditor extends React.Component<PatientMindfulnessPlansEditorProps> {

    constructor(props: PatientMindfulnessPlansEditorProps) {
        super(props);
    }

    onLabTestRemove = (index: number) => {
        let currUpdatedLabTests = Object.assign([], this.props.updatedMindfulnessPlans);
        currUpdatedLabTests.splice(index, 1);
        this.props.updateMindfulnessPlans(currUpdatedLabTests);
    }

    onLabTestChange = (updatedLifeStyle: IMeditationPrescription, index: number) => {
        let currUpdatedLabTest = Object.assign([], this.props.updatedMindfulnessPlans);
        currUpdatedLabTest[index] = updatedLifeStyle;
        this.props.updateMindfulnessPlans(currUpdatedLabTest);
    }

    onSavedMindfulnessPlanRemove = (index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.savedMindfulnessPlans);
        let updatedMindfulnessPlan: { item: MeditationPrescriptionItemRequest } = currUpdatedLifeStyle[index];
        updatedMindfulnessPlan.item.status = AppConstants.planStatus.CANCELLED;
        currUpdatedLifeStyle[index] = updatedMindfulnessPlan;
        this.props.updateSavedMindfulnessPlans(currUpdatedLifeStyle);
    }

    _handleGuidelineOnChange = (updatedGuideline: {item: PrescriptionItemGuideline}, index: number) => {
        console.log("BOTH", updatedGuideline, index);
        let currentUpdatedGuidelines = [...this.props.updatedMindGuidelines];
        currentUpdatedGuidelines[index] = updatedGuideline;
        this.props.updateMindPlanGuidelines(currentUpdatedGuidelines);
    };

    _handleGuidelineOnRemove = (index: number) => {
        let currentUpdatedGuidelines = [...this.props.updatedMindGuidelines];
        currentUpdatedGuidelines.splice(index, 1);
        this.props.updateMindPlanGuidelines(currentUpdatedGuidelines);
    };

    _getGuidelineMeta = () => {
        return {
            doctorId: this.props.doctorId.toString(),
            doctorType: AppUtils.getPlanMetaDoctorType(this.props.doctorType),
            doctorName: this.props.doctorName,
            consultationId: this.props.consultationId
        }
    }

    render() {
        let consultationType = this.props.consultationType;
        let consultationHeader = PatientFitnessPlansEditorHeaderInfos;
        let guidelinesListItems = this.props.updatedMindGuidelines || [];
        return (
            <div className="patient-mindfulness-plan-editor">
                <div className={"patient-mind-plan-guidelines-container"}>
                    <CustomHeader headerInfos={LifestyleGuidelinesHeaderInfos} rootCls={"patient-mind-plan-guidelines"}/>
                    <TemplatedList templateName={"mindPlanGuidelines"} listItems={guidelinesListItems} commonProps={{getGuidelineMeta: this._getGuidelineMeta}} defaultItem={{item: ModelFactory.createNewFitnessPlanGuideline(this._getGuidelineMeta())}} onItemChange={this._handleGuidelineOnChange} onItemRemove={this._handleGuidelineOnRemove}/>
                </div>
                <div className={"patient-mind-plan-container"}>
                    <CustomHeader headerInfos={consultationHeader} rootCls={"patient-mindfulness-plan"}/>
                    {
                        !_isEmpty(this.props.savedMindfulnessPlans) &&
                        <TemplatedList templateName={"mindfulnessPlan"} commonProps={{consultationType, fetchFitnessActivities: this.props.fetchFitnessActivities}}
                                       defaultItem={{item: ModelFactory.createNewFitnessPlanPrescriptionItem("MIND")}}
                                       listItems={this.props.savedMindfulnessPlans}
                                       onItemRemove={this.onSavedMindfulnessPlanRemove}
                                       autoAddNewRow={false} preventRowAddition={true}/>
                    }
                    <TemplatedList templateName={"mindfulnessPlan"} commonProps={{fetchFitnessActivities: this.props.fetchFitnessActivities, consultationType}}
                                   defaultItem={{item: ModelFactory.createNewFitnessPlanPrescriptionItem("MIND")}}
                                   listItems={this.props.updatedMindfulnessPlans}
                                   onItemRemove={this.onLabTestRemove}
                                   onItemChange={this.onLabTestChange}/>
                </div>
            </div>
        );
    }
}

export default MindfulnessPlansEditor